export default "__VITE_ASSET__CpwNBsRL__"